import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';

const NcContext = createContext();
export const useNcContext = () => useContext(NcContext);

export const NcProvider = ({ children }) => {
    const [ncData, setNcData] = useState({ name: "", phoneNo: "" });

    const postNc = useCallback(async (customerId, tableNo, id) => {
        try {
            await axios.post(`https://api.rcb.tdrsoftware.in/api/postNc`, { customerId, data: { tableNo, id } });
        } catch (error) {
            console.error(error);
        }
    }, []);

    const getNc = useCallback(async (customerId, tableNo) => {
        try {
            const response = await axios.get(`https://api.rcb.tdrsoftware.in/api/getNcByTable/${customerId}/${tableNo}`);
            if (response.data.nc.length > 0) {
                setNcData({
                    name: response.data.nc[0].name,
                    phoneNo: response.data.nc[0].phoneNo,
                });
            } else {
                setNcData({ name: "", phoneNo: "" });
            }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setNcData({ name: "", phoneNo: "" });
            }
        }
    }, []);

    const clearNc = useCallback(async (customerId, tableNo) => {
        try {
            await axios.delete(`https://api.rcb.tdrsoftware.in/api/clearNc/${customerId}/${tableNo}`);
            setNcData({ name: "", phoneNo: "" });
        } catch (error) {
            console.error(error);
        }
    }, []);

    return (
        <NcContext.Provider value={{ ncData, postNc, getNc, clearNc }}>
            {children}
        </NcContext.Provider>
    );
};
